import { z } from "zod/v4";
import { baseDESchema, documentoAsociadoSchema, addDocumentoAsociadoValidation } from "./base-de-schema";

//Schema de Nota de Credito (iTiDE = 5)
// Para nota de crédito, no se requiere definir condicionOperacion ya que no tiene sección de pago
export const notaCreditoFormSchema = addDocumentoAsociadoValidation(
    baseDESchema.extend({
        ...documentoAsociadoSchema.shape,
        cMoneOpe: z.string().optional(),
        dTiCam: z.number().optional(),
        motivoEmision: z.enum(["1", "2", "3", "4", "5"]).default("1"), // iMotEmi
        tipoDocumentoAsociado: z.enum(["1", "2"]).default("1"), // No constancia para nota credito
    })
);

export type NotaCreditoFormData = z.infer<typeof notaCreditoFormSchema>;
